import { IdIdentifier, Timestamps, Timezone, UserIdentifier } from '../common';
import { VideoSettings } from '../video/video';
import { SocialProvider, YoutubeCategories } from '../social-account';

export type Series = IdIdentifier &
  Timestamps &
  UserIdentifier &
  VideoSettings & {
    name: string;
    socialAccountId?: string;
    socialAccountIds: string[];
    subjectType: SeriesSubject;
    duration: number;
    script: string;
    videosPerDay: number;
    isActive: boolean;
    systemDisableDate?: Date;
    timezone: Timezone;
    settings: SeriesSettings;
    postingSchedule?: SeriesPostingSchedule;
    hashtags?: string[];
  };

export interface SeriesSettings {
  youtubeCategoryId?: YoutubeCategories;
}

export enum SeriesSubject {
  Custom = 'custom',
  RandomAIStory = 'random-ai-story',
  ScaryStories = 'scary-stories',
  BedtimeStories = 'bedtime-stories',
  InterestingHistory = 'interesting-history',
  UrbanLegend = 'urban-legend',
  MotivationalStories = 'motivational-stories',
  FunFacts = 'fun-facts',
  LongFormJokes = 'long-form-jokes',
  LifeProTip = 'life-pro-tip',
  ELI5 = 'eli5',
  Philosophy = 'philosophy',
  ProductMarketing = 'product-marketing',
  HorrorStories = 'horror-stories',
}

export type PostingTimeSlot = {
  hour: number; // 0–23
  minute: number; // 0–59
};

export type SeriesPostingSchedule = {
  [day in DayOfWeek]: PostingTimeSlot[]; // up to 3 time slots per day
};

export enum DayOfWeek {
  Sunday = 'sunday',
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
}

export const optimalPostingTimes: Record<SocialProvider, PostingTimeSlot[]> = {
  [SocialProvider.TikTok]: [
    { hour: 9, minute: 0 },
    { hour: 13, minute: 0 },
    { hour: 18, minute: 0 },
    { hour: 21, minute: 0 },
  ],
  [SocialProvider.YouTube]: [
    { hour: 10, minute: 0 },
    { hour: 14, minute: 0 },
    { hour: 18, minute: 0 },
    { hour: 21, minute: 0 },
  ],
  [SocialProvider.Instagram]: [
    { hour: 8, minute: 0 },
    { hour: 12, minute: 0 },
    { hour: 17, minute: 0 },
    { hour: 20, minute: 0 },
  ],
  [SocialProvider.Facebook]: [
    { hour: 7, minute: 0 },
    { hour: 11, minute: 0 },
    { hour: 16, minute: 0 },
    { hour: 19, minute: 0 },
  ],
};

export const defaultTikTokSlots: PostingTimeSlot[] =
  optimalPostingTimes[SocialProvider.TikTok];
